import { fg } from '@atlassian/jira-feature-gating';
import type { ConfigurationResource, Field } from '../../types.tsx';
import type { Response } from './types.tsx';

export const transformData = (response: Response): ConfigurationResource => {
	let startDateField: Field | null = null;
	const startDateFieldNode = response.data?.jira?.startDateField;

	if (startDateFieldNode != null) {
		startDateField = {
			id: startDateFieldNode.fieldId,
			name: startDateFieldNode.name,
		};
	}

	const isLinkingEnabled = fg('fun-1440_linking_enabled_relay_migration')
		? false
		: (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;

	return {
		startDateField,
		/**
		 * @deprecated delete when cleaning up fun-1440_linking_enabled_relay_migration
		 */
		isLinkingEnabled,
	};
};
